import { useTranslation } from '@/core/i18n/useTranslation'
import { Button } from '@/shared/components/atoms/Button'

interface AddButtonProps {
	onAdd: () => void
}

export const AddButton: React.FC<AddButtonProps> = ({ onAdd }) => {
	const { t } = useTranslation('common')

	return (
		<Button
			variant="link"
			size="sm"
			onClick={onAdd}
			className="text-xs text-muted-foreground hover:text-foreground underline font-semibold leading-none p-0"
		>
			{t('actions.add')}
		</Button>
	)
}
